/* Rotating Offer Banner + Black Friday slides (Light Armor Ovens, Claude 11/4).
   Section: sections/lta-rotating-banner.liquid (+ snippets/lta-rb-bf-slide.liquid). Styles: assets/lta-rb.css.
   Black Friday mode and "% Claimed" are worked out in Liquid and passed in data attributes.
   On draft themes only, ?bf=presale|main|off and ?bfpct=NN override them for previewing. */
(function () {
  var DOT = ' · ', ARR = ' →';
  var TAG = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.6 13.4l-7.2 7.2a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function bindCopy(root) {
    root.querySelectorAll('.lta-rb-btn, .lb-bf-btn').forEach(function (b) {
      if (b.dataset.ltaCopy) return;
      b.dataset.ltaCopy = '1';
      var L = b.querySelector('.lta-rb-bl') || b;
      var orig = L.textContent;
      function ok() {
        L.textContent = 'Copied!';
        b.classList.add('ok');
        setTimeout(function () { L.textContent = orig; b.classList.remove('ok'); }, 1800);
      }
      function fb(C) {
        var t = document.createElement('textarea');
        t.value = C; t.setAttribute('readonly', ''); t.style.position = 'absolute'; t.style.left = '-9999px';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy'); ok(); } catch (x) {}
        document.body.removeChild(t);
      }
      b.addEventListener('click', function (ev) {
        ev.preventDefault();
        var C = b.getAttribute('data-code');
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(C).then(ok, function () { fb(C); });
        } else { fb(C); }
      });
    });
  }

  function words(r, mode) {
    var m = mode === 'main';
    return { lbl: m ? r.dataset.lblM : r.dataset.lblP, end: m ? r.dataset.endM : r.dataset.endP };
  }

  function subFor(sl, w) {
    if (sl.dataset.claimed === '1') return sl.dataset.code + ' All Claimed' + DOT + sl.dataset.fbpct + '% Off Still Available';
    if (sl.dataset.bar === '1') return sl.dataset.used + '% Claimed' + DOT + 'Ends ' + w.end;
    return 'Limited' + DOT + 'Ends ' + w.end;
  }

  /* Draft preview: show the slides as if NN% of the codes were used (100 = all claimed). */
  function previewPct(r, n) {
    var min = parseInt(r.dataset.barMin || '20', 10);
    r.querySelectorAll('[data-bf-slide]').forEach(function (sl) {
      var claimed = n >= 100;
      sl.dataset.claimed = claimed ? '1' : '';
      sl.dataset.used = String(Math.min(100, n));
      sl.dataset.bar = (!claimed && n > 0 && n >= min) ? '1' : '';
      var code = claimed ? sl.dataset.fb : sl.dataset.code;
      var pct = claimed ? sl.dataset.fbpct : sl.dataset.pct;
      var big = sl.querySelector('.lta-rb-big');
      if (big && big.firstChild) big.firstChild.nodeValue = pct;
      var c = sl.querySelector('.lta-rb-code'); if (c) c.textContent = code;
      var b = sl.querySelector('.lta-rb-btn');
      if (b) { b.setAttribute('data-code', code); b.setAttribute('aria-label', 'Copy Discount Code ' + code); }
    });
  }

  function apply(r, mode) {
    var hide = (r.dataset.hide || '').split(',');
    var w = words(r, mode);
    r.querySelectorAll('.lta-rb-slide').forEach(function (x) {
      var isBf = x.hasAttribute('data-bf-slide');
      var show = isBf ? mode !== 'off'
        : !(mode !== 'off' && x.dataset.stdCode && hide.indexOf(x.dataset.stdCode) > -1);
      if (!show) { x.parentNode.removeChild(x); return; }
      x.classList.remove('lta-rb-x', 'is-on');
      if (isBf) {
        var l = x.querySelector('[data-bf-lbl]');
        var s = x.querySelector('[data-bf-sub]');
        if (l) l.textContent = w.lbl;
        if (s) s.textContent = subFor(x, w) + ARR;
      }
    });
  }

  function carousel(r) {
    if (r.dataset.ltaInit) return;
    r.dataset.ltaInit = '1';
    var SPEED = (parseFloat(r.getAttribute('data-speed')) || 4) * 1000;
    var sl = r.querySelectorAll('.lta-rb-slide'), dw = r.querySelector('.lta-rb-dots');
    var i = 0, t = null, hold = false, rm = window.matchMedia('(prefers-reduced-motion:reduce)');
    sl.forEach(function (x, k) { x.setAttribute('aria-label', (k + 1) + ' of ' + sl.length); dw.appendChild(document.createElement('i')); });
    var dots = dw.querySelectorAll('i');
    if (sl.length < 2) { r.querySelectorAll('.lta-rb-nav').forEach(function (b) { b.style.display = 'none'; }); dw.style.display = 'none'; }
    if (!sl.length) { r.style.display = 'none'; return; }
    function go(n) {
      i = (n + sl.length) % sl.length;
      sl.forEach(function (x, k) {
        var on = k === i;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-hidden', on ? 'false' : 'true');
        x.querySelectorAll('a,button').forEach(function (c) { c.tabIndex = on ? 0 : -1; });
      });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    }
    function stop() { if (t) { clearInterval(t); t = null; } }
    function start() { stop(); if (sl.length > 1 && !hold && !rm.matches && !document.hidden) { t = setInterval(function () { go(i + 1); }, SPEED); } }
    function user(n) { go(n); start(); }
    r.querySelector('.lta-rb-prev').addEventListener('click', function (ev) { ev.preventDefault(); user(i - 1); });
    r.querySelector('.lta-rb-next').addEventListener('click', function (ev) { ev.preventDefault(); user(i + 1); });
    r.addEventListener('mouseenter', function () { hold = true; stop(); });
    r.addEventListener('mouseleave', function () { hold = false; start(); });
    r.addEventListener('focusin', function () { hold = true; stop(); });
    r.addEventListener('focusout', function () { hold = false; start(); });
    document.addEventListener('visibilitychange', start);
    var x0 = null;
    r.addEventListener('touchstart', function (ev) { x0 = ev.touches[0].clientX; }, { passive: true });
    r.addEventListener('touchend', function (ev) {
      if (x0 === null) return;
      var dx = ev.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) user(dx < 0 ? i + 1 : i - 1);
      x0 = null;
    }, { passive: true });
    go(0); start();
  }

  /* Product pages (la-build template): Black Friday line under Add to Cart, with the % Claimed bar.
     In-stock units get the in-stock code, other LA ovens/booths the build-to-order code, LABS nothing. */
  function productLine(r, mode) {
    if (!r || mode === 'off') return;
    var cta = document.getElementById('lb-cta');
    if (!cta || !cta.querySelector('[data-lb-cart]') || document.querySelector('.lb-bf')) return;
    var tEl = document.querySelector('.lb-qs .product-info__title') || document.querySelector('h1');
    var title = ((tEl && tEl.textContent) || '').trim();
    var kind = /in-stock/i.test(title) ? 'instock' : (/^LABS/i.test(title) ? '' : 'bto');
    if (!kind) return;
    var sl = r.querySelector('[data-bf-kind="' + kind + '"]');
    if (!sl) return;
    var w = words(r, mode);
    var claimed = sl.dataset.claimed === '1';
    var code = claimed ? sl.dataset.fb : sl.dataset.code;
    var bar = !claimed && sl.dataset.bar === '1';
    var used = esc(sl.dataset.used || '0');
    var msg = claimed
      ? esc(sl.dataset.code) + ' Is All Claimed. Use Code <b>' + esc(sl.dataset.fb) + '</b> For ' + esc(sl.dataset.fbpct) + '% Off.'
      : esc(sl.dataset.pct) + '% Off With Code <b>' + esc(sl.dataset.code) + '</b>' + DOT + 'Limited' + DOT + 'Ends ' + esc(w.end);
    var meter = bar
      ? '<span class="lb-bf-meter"><span class="lb-bf-bar" role="img" aria-label="' + used + '% claimed"><i style="width:' + used + '%"></i></span><span class="lb-bf-pc">' + used + '% Claimed</span></span>'
      : '';
    var d = document.createElement('div');
    d.className = 'lb-bf';
    d.innerHTML = '<span class="lb-bf-ic" aria-hidden="true">' + TAG + '</span>' +
      '<span class="lb-bf-tx"><span><b>' + esc(w.lbl) + ':</b> ' + msg + '</span>' + meter + '</span>' +
      '<button type="button" class="lb-bf-btn" data-code="' + esc(code) + '" aria-label="Copy Discount Code ' + esc(code) + '"><span class="lta-rb-bl">Copy Code</span></button>';
    cta.parentNode.insertBefore(d, cta.nextSibling);
  }

  function init() {
    var r = document.querySelector('.lta-rb');
    if (r) {
      var s = r.closest('.section') || r.parentElement;
      if (s && s !== document.body) {
        s.style.padding = '0'; s.style.margin = '0'; s.style.maxWidth = 'none';
        var p = r.parentElement;
        while (p && p !== s) { p.style.maxWidth = 'none'; p.style.padding = '0'; p.style.margin = '0'; p = p.parentElement; }
      }
    }
    var mode = r ? (r.getAttribute('data-bf') || 'off') : 'off';
    var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
    var draft = !!role && role !== 'main';
    if (draft && r) {
      var q = (location.search.match(/[?&]bf=(presale|main|off)\b/) || [])[1] || null;
      var qp = (location.search.match(/[?&]bfpct=(\d{1,3})\b/) || [])[1] || null;
      try {
        if (q) sessionStorage.setItem('ltaBf', q); else q = sessionStorage.getItem('ltaBf');
        if (qp) sessionStorage.setItem('ltaBfPct', qp); else qp = sessionStorage.getItem('ltaBfPct');
      } catch (e) {}
      if (q && r.getAttribute('data-bf-enable') === 'true') mode = q;
      if (qp !== null && qp !== '') previewPct(r, parseInt(qp, 10));
    }
    window.LTA_BF = { mode: mode };
    if (r) { apply(r, mode); carousel(r); }
    productLine(r, mode);
    bindCopy(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();